import type { FC } from 'react';

import { Box } from '@mui/material';
import { useCallback } from 'react';

import { CenterBox } from '../../utils/center-box';
import { PPButton } from '../pp-button';
import { SurveyBoxGenericFooterBtnWidth } from './survey-box-generic-footer';

export interface SubmitButtonProps {
  onClick?: (e: MouseEvent) => Promise<void> | void;
  label?: string;
}

function inIFrame() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

const DEFAULT_ON_CLICK = () => {
  if (inIFrame()) {
    if (window.parent && typeof window.parent.postMessage === 'function') {
      window.parent.postMessage('close-window', '*');
    }
  }
  window.close();
};

const DEFAULT_LABEL = `Close preview`;

export const CloseButton: FC<SubmitButtonProps> = ({ onClick, label }) => {
  // eslint-disable-next-line react-hooks/use-memo
  const defaultOnClick = useCallback(DEFAULT_ON_CLICK, []);
  return (
    <CenterBox>
      <Box sx={{ flexGrow: 1, maxWidth: SurveyBoxGenericFooterBtnWidth, margin: '10px' }}>
        <PPButton onClick={onClick || defaultOnClick} sx={{ width: '100%' }}>
          {label || DEFAULT_LABEL}
        </PPButton>
      </Box>
    </CenterBox>
  );
};
